export const LOGICAL_ACTIONS = [
  'left', 'right', 'down', 'guard', 'light', 'heavy', 'skill1', 'skill2', 'super', 'jump',
] as const;

export type LogicalAction = (typeof LOGICAL_ACTIONS)[number];

export const BUFFERED_ACTIONS = ['light', 'heavy', 'skill1', 'skill2', 'super', 'jump'] as const;
export type BufferedAction = (typeof BUFFERED_ACTIONS)[number];

export const HELD_ACTIONS = ['left', 'right', 'down', 'guard'] as const;
export type HeldAction = (typeof HELD_ACTIONS)[number];

export type InputFrame = Readonly<Record<LogicalAction, boolean>>;

const EMPTY_INPUT_VALUES: Record<LogicalAction, boolean> = {
  left: false,
  right: false,
  down: false,
  guard: false,
  light: false,
  heavy: false,
  skill1: false,
  skill2: false,
  super: false,
  jump: false,
};

export const createInputFrame = (values: Partial<Record<LogicalAction, boolean>> = {}): InputFrame =>
  Object.freeze({ ...EMPTY_INPUT_VALUES, ...values });

export const EMPTY_INPUT_FRAME = createInputFrame();

export const assertInputFrame = (frame: InputFrame, name = 'inputFrame'): void => {
  if (typeof frame !== 'object' || frame === null) throw new TypeError(`${name} must be an object.`);
  for (const action of LOGICAL_ACTIONS) {
    if (typeof frame[action] !== 'boolean') throw new TypeError(`${name}.${action} must be boolean.`);
  }
};
